import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookmarkFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-248.89 -348.44 1777.78 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1164 1408Q1187 1408 1208 1399Q1241 1386 1260.5 1358.0Q1280 1330 1280 1296V7Q1280 -27 1260.5 -55.0Q1241 -83 1208 -96Q1189 -104 1164 -104Q1116 -104 1081 -72L640 352L199 -72Q163 -105 116 -105Q93 -105 72 -96Q39 -83 19.5 -55.0Q0 -27 0 7V1296Q0 1330 19.5 1358.0Q39 1386 72 1399Q93 1408 116 1408Z"
	})
});
export default SvgBookmarkFill;
